import React from "react";

export const Launchpad = () => (
  <svg
    id="Capa_1"
    height="25"
    width="25"
    fill="#fff"
    enableBackground="new 0 0 512 512"
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path d="m345.73 0-.01.04v-.04c-29.97 24.17-53.74 57.45-59.49 95.6h118.99c-5.75-38.15-29.52-71.43-59.49-95.6z" />
      <path d="m461.07 482v-47.45c0-19.02-15.47-34.49-34.48-34.49-19.02 0-34.49 15.47-34.49 34.49v47.45h-92.76v-47.45c0-19.02-15.47-34.49-34.48-34.49-19.02 0-34.49 15.47-34.49 34.49v47.45h-33.78v-128.83h68.27v16.89c37.294 0 66.332 32.479 64.48 69.13h32.76c-1.852-36.658 27.194-69.13 64.49-69.13v-55.52h-161.73v8.63h-68.27v-47.25h68.27v8.62h161.73v-158.94h-161.73v120.32h-68.27v-245.92h-145.66v482h-50.93v30h512v-30zm-130.345-290.87h30v30h-30zm-249.795-129.62 71.37 99.15h-71.37zm0 129.16h71.37l-71.37 99.15zm0 291.33v-99.16l71.38 99.16zm85.66-31.51-71.38-99.16h71.38zm0-129.16h-71.38l71.38-99.15zm0-192.17-71.38-99.16h71.38z" />
    </g>
  </svg>
);
